import jwt_decode from "jwt-decode";
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const absNum = Math.abs(Number(num));

  if (absNum >= 1.0e12) {
    return (num / 1.0e12).toFixed(1).replace(/\.0$/, "") + "T"; // Trillions
  } else if (absNum >= 1.0e9) {
    return (num / 1.0e9).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
  } else if (absNum >= 1.0e6) {
    return (num / 1.0e6).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
  } else if (absNum >= 1.0e3) {
    return (num / 1.0e3).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
  }
  return num.toString(); // Less than 1K, show full number
};
// export function toFixedWithoutRounding(num, decimals = 2) {
//   // Convert to string
//   if (Math.abs(Number(num)) > 0) {
//     const str = num?.toString();

//     // Find decimal point position
//     const decimalIndex = str?.indexOf(".");

//     // If there's no decimal, add zeros
//     if (decimalIndex === -1) {
//       return str + "." + "0".repeat(decimals);
//     }

//     // Extract integer + desired decimal digits
//     const fixed = str.substring(0, decimalIndex + decimals + 1);

//     // If decimal digits are less, pad with zeros
//     const decimalPart = fixed?.split(".")[1] || "";
//     return fixed + "0".repeat(decimals - decimalPart?.length);
//   } else {
//     return 0.0;
//   }

//   // const factor = Math.pow(10, decimals);
//   // return Math.trunc(num * factor) / factor;
// }

export function toFixedWithoutRounding(num, decimals = 2) {
  const number = Number(num);
  if (isNaN(number)) return (0).toFixed(decimals);

  const isNegative = number < 0;
  const str = Math.abs(number).toString();

  // Guard against scientific notation (e.g. very small/large numbers like 1e-7)
  if (str.includes("e")) {
    return number.toFixed(decimals); // fallback to normal rounding for these edge cases
  }

  const decimalIndex = str.indexOf(".");
  let result;

  if (decimalIndex === -1) {
    result = str + "." + "0".repeat(decimals);
  } else {
    const fixed = str.substring(0, decimalIndex + decimals + 1);
    const decimalPart = fixed.split(".")[1] || "";
    result = fixed + "0".repeat(Math.max(0, decimals - decimalPart.length));
  }

  return isNegative ? "-" + result : result;
}

export const getDecodedToken = () => {
  const token = localStorage.getItem("token");
  return token ? jwt_decode(token) : null;
};
export const formatWithCommas = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "0";
  return Number(num).toLocaleString("en-IN");
};

export const betCheckObj = {
  4: "Cricket",
  2: "Tennis",
  1: "Soccer",
  3: "Casino",
};
export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/,
  passwordMessage:
    "Password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  characters: /^[a-zA-Z_ ]*$/,
  numbers: /^[0-9]*$/,
  removeWhitespace: /^[a-zA-Z0-9]+$/,
  numberNew: /^[0-9]*$/,
  numberWithDot: /^\d*(\.\d{0,10})?$/,
};

export const removeSPrefix = (classes) =>
  classes
    .split(" ")
    .map((cls) => cls.replace(/^s-/, ""))
    .join(" ");
